import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface NavigationState {
  activeTab: string
  sidebarOpen: boolean
  // 详情页用:整段替换 TopBar 标题(如 "Task #1234")
  pageTitle: string | null
  // 页面标题下方的小灰字副标题(仅在 pageTitle 存在时渲染,如 KB 的 "Centralized governance")
  pageSubtitle: string | null
  // 列表页用:当前选中 view 的名字,TopBar 渲染为路由标题后的面包屑("Tasks › Maintenance")
  activeViewName: string | null
}

const initialState: NavigationState = {
  activeTab: "dashboard",
  sidebarOpen: true,
  pageTitle: null,
  pageSubtitle: null,
  activeViewName: null,
}

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload
    },
    setPageTitle: (state, action: PayloadAction<string | null>) => {
      state.pageTitle = action.payload
    },
    setPageSubtitle: (state, action: PayloadAction<string | null>) => {
      state.pageSubtitle = action.payload
    },
    setActiveViewName: (state, action: PayloadAction<string | null>) => {
      state.activeViewName = action.payload
    },
  },
})

export const {
  setActiveTab,
  toggleSidebar,
  setSidebarOpen,
  setPageTitle,
  setPageSubtitle,
  setActiveViewName,
} = navigationSlice.actions
export default navigationSlice.reducer
